export interface CartModel {
  totalAmount: number;
  shippingFee: number;
  couponCode: string;
  discountAmount: number;
  phoneNumber: string;
  email: string;
  name: string;
  shipName: string;
  shipPhoneNumber: string;
  address: string;
  addressId: string | number;
  districtId: number | string;
  districtName: string;
  provinceId: number | string;
  provinceName: string;
  wardId?: number | string;
  wardName?: string;
  subTotalAmount: number;
  customerId: number| string;
  customerName: string;
  shoppingCartItems: ShoppingCartItem[];
}
export interface OrderModel {
  id: number| string;
  orderNumber: string;
  totalAmount: number;
  shippingFee: number;
  couponCode: string;
  discountAmount: number;
  phoneNumber: string;
  email: string;
  name: string;
  shipName: string;
  shipPhoneNumber: string;
  address: string;
  districtId: number | string;
  districtName: string;
  provinceId: number | string;
  provinceName: string;
  wardId?: number | string;
  wardName?: string;
  subTotalAmount: number;
}
export interface ShoppingCartItem{
  skuId: number | string;
  price: number;
  quantity: number;
  skuName: string;
  skuImage: string;
}
export interface AddItemModel{
  skuId: number | string;
  quantity: number;
}
export interface UpdateItemModel{
  skuId: number | string;
  quantity: number;
}
export interface ApplyCouponModel{
  couponCode: string;
}
export interface UpdateAddressModel{
  addressId: number | string;
}

export interface WebsiteAddShoppingCartItemModel{
  items: AddItemModel[];
  shoppingCart: OrderModel;
}
export interface WebsiteUpdateShoppingCartItemModel{
  item: AddItemModel;
  shoppingCart: OrderModel;
}

export interface WebsiteRemoveShoppingCartItemModel{
  skuId: string | number;
  shoppingCart: OrderModel;
}

export interface WebsiteRemoveCouponShoppingCartModel{
  shoppingCart: OrderModel;
}

export interface WebsiteApplyCouponShoppingCartModel{
  couponCode: string;
  shoppingCart: OrderModel;
}


// Provide Action Type
export const Set_Cart = "Set_Cart";
interface SetCart {
  type: typeof Set_Cart;
  payload: CartModel;
}
export type CartActionType = SetCart;